import { motion } from 'framer-motion'
import { getServices } from '../data'
import { L, useLocale, useT } from '../i18n/locale.jsx'

// Departamentele B2B servite. La hover pe rând: numele se umple în honey și apare
// în dreapta, pe același rând, descriptorul cu soluțiile (text mic).
export default function Services() {
  const locale = useLocale()
  const t = useT().services
  const services = getServices(locale)
  return (
    <section id="services" data-theme="light" className="px-5 pb-28 text-ink md:px-10 md:pb-40">
      <p className="eyebrow mb-10 text-right">{t.eyebrow} ✦</p>

      <ul className="mx-auto max-w-site">
        {services.map((s, i) => (
          <motion.li
            key={s.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '0px 0px -10% 0px' }}
            transition={{ duration: 0.6, delay: 0.1 + i * 0.05, ease: [0.16, 1, 0.3, 1] }}
            data-cursor
          >
            <L
              to={`/${s.slug}`}
              className="group flex flex-col gap-2 py-1 md:flex-row md:items-baseline md:justify-between md:gap-8"
            >
              <span
                className={`display select-none text-[14vw] leading-[0.96] md:text-[10vw] ${
                  i % 2 === 1 ? 'svc-filled' : 'svc-outline'
                }`}
              >
                {s.name}
              </span>
              {/* descriptor MEREU vizibil (ink-soft 7,78:1) — nu doar la hover, nu doar pe lg */}
              <span className="max-w-[30ch] shrink-0 font-mono text-[12px] leading-relaxed text-ink-soft md:max-w-[26ch] md:pb-3 md:text-right md:text-[13px]">
                {s.desc}
              </span>
            </L>
          </motion.li>
        ))}
      </ul>
    </section>
  )
}
